<div class="info-user-page">
  <!-- Loading -->
  <div *ngIf="loadingPage" class="container-lottie">
    <div class="loading-container">
      <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
        containerClass="loading-box"></ng-lottie>
    </div>
  </div>

  <div *ngIf="!loadingPage">

    <!-- 2-column layout -->
    <div class="profile-grid">

      <!-- Left column -->
      <div class="profile-left-col">

      <!-- Card 1: Avatar -->
      <div class="profile-card avatar-card">
        <div class="avatar-wrapper" (click)="file.click()">
          <div class="avatar-img">
            <img [src]="imgControl.value" alt="Foto de perfil" />
          </div>
          <div class="camera-btn">
            <i class="fa-light fa-camera"></i>
          </div>
          <input id="file" #file hidden type="file" accept="image/*" (change)="onFileChange($event)">
        </div>
        <p class="user-name">{{user?.name}}</p>
        <button class="update-photo-btn" (click)="file.click()">
          <i class="fa-light fa-arrow-up-from-bracket"></i>
          Actualizar foto
        </button>
      </div>

      <!-- Card 3: Roles -->
      <div class="profile-card roles-card">
        <div class="card-header">
          <div class="card-header-left">
            <i class="fa-light fa-shield-halved card-icon"></i>
            <h3 class="card-title">Roles y funciones de usuario</h3>
          </div>
          <span class="card-tag">SEGURIDAD</span>
        </div>
        <div class="card-body">
          <div class="role-item" *ngFor="let role of rolesUser; let i = index" [ngClass]="'role-color-' + (i % 5)">
            <p class="role-name">{{role.name}}</p>
            <p class="role-desc">{{getRoleDescription(role.name)}}</p>
          </div>
          <p class="no-data" *ngIf="!rolesUser?.length">No hay roles asignados.</p>
        </div>
      </div>

      </div><!-- /profile-left-col -->

      <!-- Right column -->
      <div class="profile-right-col">

      <!-- Card 2: Account Info -->
      <div class="profile-card">
        <div class="card-header">
          <div class="card-header-left">
            <i class="fa-light fa-user card-icon"></i>
            <h3 class="card-title">Información de la Cuenta</h3>
          </div>
          <span class="card-tag">GENERAL</span>
        </div>
        <div class="card-body">
          <div class="field-group">
            <label class="field-label">NOMBRE / ORGANIZACIÓN</label>
            <div class="field-input clickable" (click)="openChangeName()">
              <span>{{user?.name}}</span>
              <i class="fa-light fa-pen field-icon"></i>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">CUENTA (EMAIL)</label>
            <div class="field-input">
              <span>{{user?.email}}</span>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">CONTRASEÑA</label>
            <div class="field-input clickable" (click)="openChangePassword()">
              <span class="password-dots">•••••••••</span>
              <i class="fa-light fa-pen field-icon"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 4: Spaces -->
      <div class="profile-card">
        <div class="card-header">
          <div class="card-header-left">
            <i class="fa-light fa-location-dot card-icon"></i>
            <h3 class="card-title">Espacios vinculados</h3>
          </div>
          <!-- <button class="card-tag card-tag-add"><i class="fa-light fa-circle-plus"></i> Añadir</button> -->
        </div>
        <div class="card-body">
          <div class="spaces-grid" *ngIf="placesUser?.length > 0">
            <div class="space-item" *ngFor="let place of placesUser" (click)="goToPlace(place)">
              <div class="space-icon-wrap">
                <i class="fa-light fa-building"></i>
              </div>
              <div class="space-info">
                <p class="space-name">{{place.name}}</p>
                <p class="space-subtitle" *ngIf="place.address || place.location">
                  {{place.address || place.location}}
                </p>
              </div>
            </div>
          </div>
          <p class="no-data" *ngIf="!placesUser?.length">No hay espacios vinculados aún.</p>
        </div>
      </div>

      </div><!-- /profile-right-col -->

    </div>

    <!-- Logout -->
    <div class="logout-card" (click)="logout()">
      <i class="fa-light fa-arrow-right-from-bracket"></i>
      <p class="m-0">Cerrar sesión</p>
    </div>

  </div>
</div>

